<template>
	<div>
		<b-form class="needs-validation">
			<b-row v-if="editStatus">
				<b-col xl="4" lg="4" sm="4">
					<p class="mt-3">
						<span class="h3">Tower Identifier</span>
					</p>
				</b-col>
				<b-col xl="8" lg="8" sm="8">
					<b-form-group label-for="input-1">
						<b-form-input
							id="input-1"
							disabled
							type="number"
							max="20"
							:state="true"
							v-model="towerInformationForm.id"
						></b-form-input>
						<b-form-invalid-feedback :state="true"> Please enter a valid Id </b-form-invalid-feedback>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col xl="4" lg="4" sm="4">
					<p class="mt-3">
						<span class="h3">Radio Access Technology (RAT)</span>
					</p>
				</b-col>
				<b-col xl="8" lg="8" sm="8">
					<b-form-group label-for="input-1">
						<b-form-select
							id="period"
							v-model="towerInformationForm.radioAccess"
							:options="radioAccessOption"
							:state="radioAccessStatus"
							value-field="key"
							class="mt-2"
							text-field="label"
						></b-form-select>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col xl="4" lg="4" sm="4">
					<p class="mt-3">
						<span class="h3">Mobile Country Code(MCC)</span>
					</p>
				</b-col>
				<b-col xl="8" lg="8" sm="8">
					<b-form-group label-for="input-1">
						<b-form-input
							id="input-1"
							:state="countryCodeStatus"
							v-model="towerInformationForm.countryCode"
							type="number"
						></b-form-input>
						<b-form-invalid-feedback :state="countryCodeStatus">
							Please enter a valid mcc
						</b-form-invalid-feedback>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col xl="4" lg="4" sm="4">
					<p class="mt-3">
						<span class="h3">Mobile Network Code (MNC)</span>
					</p>
				</b-col>
				<b-col xl="8" lg="8" sm="8">
					<b-form-group label-for="input-1">
						<b-form-input
							id="input-1"
							:state="networkCodeStatus"
							v-model="towerInformationForm.networkCode"
							type="number"
						></b-form-input>
						<b-form-invalid-feedback :state="networkCodeStatus">
							Please enter a valid mnc
						</b-form-invalid-feedback>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col xl="4" lg="4" sm="4">
					<p class="mt-3">
						<span class="h3">Location Area Code</span>
					</p>
				</b-col>
				<b-col xl="8" lg="8" sm="8">
					<b-form-group label-for="input-1">
						<b-form-input
							id="input-1"
							:state="areaCodeStatus"
							v-model="towerInformationForm.areaCode"
							type="number"
						></b-form-input>
						<b-form-invalid-feedback :state="areaCodeStatus">
							Please enter a valid lac.
						</b-form-invalid-feedback>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col xl="4" lg="4" sm="4">
					<p class="mt-3">
						<span class="h3">Cell ID(CID)</span>
					</p>
				</b-col>
				<b-col xl="8" lg="8" sm="8">
					<b-form-group label-for="input-1">
						<b-form-input
							id="input-1"
							:state="cellIdStatus"
							v-model="towerInformationForm.cellId"
							type="number"
						></b-form-input>
						<b-form-invalid-feedback :state="cellIdStatus">
							Please enter a valid cid.
						</b-form-invalid-feedback>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col xl="4" lg="4" sm="4">
					<p class="mt-3">
						<span class="h3">Latitude</span>
					</p>
				</b-col>
				<b-col xl="8" lg="8" sm="8">
					<b-form-group label-for="input-1">
						<b-form-input
							id="input-1"
							:state="latitudeStatus"
							v-model="towerInformationForm.latitude"
							type="number"
						></b-form-input>
						<b-form-invalid-feedback :state="latitudeStatus">
							Please enter a valid latitude
						</b-form-invalid-feedback>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col xl="4" lg="4" sm="4">
					<p class="mt-3">
						<span class="h3">Longitude</span>
					</p>
				</b-col>
				<b-col xl="8" lg="8" sm="8">
					<b-form-group label-for="input-1">
						<b-form-input
							id="input-1"
							type="number"
							:state="longitudeStatus"
							v-model="towerInformationForm.longitude"
							placeholder=""
						></b-form-input>
						<b-form-invalid-feedback :state="longitudeStatus">
							Please enter a valid longitude
						</b-form-invalid-feedback>
					</b-form-group>
				</b-col>
			</b-row>
			<hr />
			<div class="mt-3 d-flex justify-content-between">
				<base-button type="white" title="Close"  v-on:click="modalClose()">
					Close
				</base-button>
				<base-button type="primary" title="Submit"  v-on:click="towerInformationSubmit" :loading="submitLoading">
					Submit
				</base-button>
			  </div>
		</b-form>
	</div>
</template>

<script>
import administratorService from "../../common/api-services/administrator-service";
import handleResponse from "../../common/directive/handlResponse";

export default {
	name: "Add-Tower-Information",
	computed: {
		radioAccessStatus() {
			return this.towerInformationForm.radioAccess.length > 0;
		},
		countryCodeStatus() {
			return this.towerInformationForm.countryCode.length > 0;
		},
		networkCodeStatus() {
			return this.towerInformationForm.networkCode.length > 0;
		},
		areaCodeStatus() {
			return this.towerInformationForm.areaCode.length > 0;
		},
		cellIdStatus() {
			return this.towerInformationForm.cellId.length > 0;
		},
		latitudeStatus() {
			return this.towerInformationForm.latitude.length > 0 && this.towerInformationForm.latitude < 1000;
		},
		longitudeStatus() {
			return this.towerInformationForm.longitude.length > 0 && this.towerInformationForm.longitude < 1000;
		},
	},
	data() {
		return {
			towerInformationForm: {
				radioAccess: "",
				countryCode: "",
				networkCode: "",
				areaCode: "",
				cellId: "",
				latitude: "",
				longitude: "",
				id: "",
			},
			radioAccessOption: [],
			editStatus: false,
			submitLoading: false,
		};
	},
	mounted() {
		this.$root.$on("editTowerInformation", res => {
			if (res.status) {
				this.editStatus = true;
				this.towerInformationForm.id = res.item.id;
				this.towerInformationForm.radioAccess = res.item.radio ? res.item.radio : "";
				this.towerInformationForm.countryCode =
					res.item.mcc && typeof res.item.mcc === "number" ? res.item.mcc : "";
				this.towerInformationForm.networkCode = res.item.mnc ? res.item.mnc : "";
				this.towerInformationForm.areaCode = res.item.lac ? res.item.lac : "";
				this.towerInformationForm.cellId = res.item.cell ? res.item.cell : "";
				this.towerInformationForm.latitude = res.item.lat ? res.item.lat : "";
				this.towerInformationForm.longitude = res.item.lon ? res.item.lon : "";
			}
		});
		this.getRadioAccess();
	},
	methods: {
		getRadioAccess() {
			administratorService.getTowerRadioList().then(res => {
				if (res && !res.includes('NULL') && !res.includes('FAIL')) {
					res.map(item => {
						this.radioAccessOption.push({key: item.radio, label: item.radio});
					});
				}
			});
		},
		modalClose() {
			this.$bvModal.hide("tower-management");
		},

		towerInformationSubmit() {
			if (
				this.radioAccessStatus &&
				this.countryCodeStatus &&
				this.networkCodeStatus &&
				this.areaCodeStatus &&
				this.cellIdStatus &&
				this.latitudeStatus &&
				this.longitudeStatus
			) {
				this.submitLoading = true;
				if (this.editStatus) {
					this.updateTowerData("IOT_AddTower");
				} else {
					this.updateTowerData("IOT_EditTower");
				}
			}
		},

		updateTowerData(method) {
			administratorService.addTower(method, this.towerInformationForm).then(res => {
				this.submitLoading = false;
				let {type, msg} = handleResponse.apiResponse(res);
				this.$toast(msg, {type: type})
				this.modalClose();
				this.$root.$emit("addTowerInformation");
			});
		},
	},
};
</script>

<style scoped></style>
